<template>
  <v-flex xs10>
    <label class="darkblue--text">Approval Type</label>
    <v-radio-group v-model="groupList.type" row class="mt-0 mb-2">
      <v-radio label="Conventional" value="conventional"></v-radio>
      <v-radio label="Conditional" value="conditional"></v-radio>
    </v-radio-group>
    <div v-if="groupList.type === 'conditional'">
      <label class="darkblue--text">Approval Flow Type</label>
      <v-radio-group v-model="groupList.approval_flow" row class="mt-0 mb-2">
        <v-radio
          label="Bulk"
          value="bulk"
          @change="changeApprovalFlow('bulk')"
        ></v-radio>
        <v-radio
          label="Single"
          value="single"
          @change="changeApprovalFlow('single')"
        ></v-radio>
      </v-radio-group>
    </div>
    <v-btn
      v-if="groupList.type === 'conditional'"
      color="green"
      class="mt-1 mb-5 white--text"
      @click="addCondition"
    >
      <v-icon>add</v-icon> add condition
    </v-btn>
    <v-btn
      v-if="groupList.approval_flow === 'single'"
      color="primary"
      class="mt-1 mb-5 ml-5 white--text"
      @click="setEmail"
    >
      set email time
    </v-btn>
    <v-expansion-panels width="100%" v-model="parentPanel">
      <v-expansion-panel
        v-for="(item, indexCondition) in groupList.condition"
        :key="'condition' + indexCondition"
        flat
        class="mb-5"
        width="100%"
      >
        <v-expansion-panel-header class="px-4">
          <v-row no-gutters>
            <v-col
              cols="auto"
              :class="groupList.type === 'conditional' ? 'mt-2' : ''"
            >
              {{
                groupList.type === 'conventional'
                  ? 'Config Approval'
                  : 'Condition:'
              }}
            </v-col>
            <v-col
              cols="auto"
              class="ml-3 mt-2"
              v-if="groupList.type === 'conditional'"
            >
              <v-fade-transition leave-absolute>
                <span key="1">
                  {{ idr(item.amount) }} -
                  {{
                    item.max_amount
                      ? idr(item.max_amount)
                      : item.max_infinite
                      ? 'infinity'
                      : idr(item.max_amount)
                  }}
                </span>
              </v-fade-transition>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto">
              <v-btn
                v-if="
                  groupList.type === 'conditional' &&
                    !isDetail &&
                    groupList.condition.length > 1
                "
                color="red"
                class="mr-3 white--text"
                @click="removeCondition(item, indexCondition)"
              >
                <v-icon>delete_outline</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row no-gutters v-if="groupList.type !== 'conventional'">
            <v-col cols="4">
              <label class="darkblue--text">Min IO Amount</label>
              <v-currency-field
                id="min-amount"
                re
                label="Min IO Amount"
                name="Min IO Amount"
                single-line
                v-model="item.amount"
                outlined
                hide-details
              />
            </v-col>
            <v-col cols="4" class="ml-3">
              <label class="darkblue--text">Max IO Amount</label>
              <v-currency-field
                id="max-amount"
                label="Max IO Amount"
                name="Max IO Amount"
                single-line
                v-model="item.max_amount"
                :disabled="item.max_infinite"
                outlined
                hide-details
              />
              <span v-if="item.error_message" key="0" class="red--text fs-11">
                {{ item.error_message }}
              </span>
              <v-checkbox
                v-model="item.max_infinite"
                label="Max IO amount to infinity"
                class="mt-0"
                style="margin-left: -5px"
                @change="handleInfinite(item)"
              ></v-checkbox>
            </v-col>
            <v-col cols="1">
              <v-btn
                id="btn-save-condition"
                block
                color="blue darken-3"
                class="white--text mt-6 ml-3"
                @click="updateCondition(item)"
              >
                Update
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="px-3 mt-3">
            <v-expansion-panels width="100%" v-model="panel">
              <v-expansion-panel
                v-for="group in item.group"
                :key="group.id"
                class="mb-5 rounded-10"
                width="100%"
                @click="getBO(group)"
              >
                <v-expansion-panel-header
                  expand-icon="keyboard_arrow_down"
                  class="primary pr-5 pl-0 py-0 rounded-bottom-left-10 rounded-bottom-right-10"
                >
                  <template v-slot:actions>
                    <v-icon color="white" style="font-size: 23px !important;">
                      keyboard_arrow_down
                    </v-icon>
                  </template>
                  <template>
                    <v-row no-gutters>
                      <span
                        class="pl-5 font-weight-bold fs-14 white--text align-self-center text-capitalize"
                      >
                        {{ group.name }}
                      </span>
                    </v-row>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pa-0">
                  <v-perfect-scroll class="level-dialog">
                    <v-form
                      @submit.prevent="
                        saveConfirm(
                          'save',
                          group.listType,
                          group,
                          group,
                          indexCondition
                        )
                      "
                      class="pa-0"
                    >
                      <v-radio-group v-model="group.listType" row class="pt-0">
                        <v-radio label="By Group" value="group"></v-radio>
                        <v-radio label="By Budget Owner" value="bo"></v-radio>
                      </v-radio-group>
                      <v-card-text>
                        <v-container
                          v-if="group.listType === 'group'"
                          class="pa-0 form-filter pb-2"
                        >
                          <form-approver
                            :groupList="groupList"
                            :approvers="group.approvers"
                            :approverList="approverList"
                            :isDetail="isDetail"
                            :panel="panel"
                            :parentPanel="parentPanel"
                          />
                          <v-row>
                            <v-col cols="10" class="fs-11 red--text lh-15 pa-0">
                              Notes: The setting for "Skip Waiting Restriction"
                              should be applied the same, for the profile which
                              available across Group, in same Division.
                            </v-col>
                          </v-row>
                        </v-container>
                        <v-container class="pa-0 form-filter pb-2" v-else>
                          <v-expansion-panels
                            flat
                            width="100%"
                            v-model="panelBO"
                          >
                            <v-expansion-panel
                              v-for="itemBo in group.budgetOwner"
                              :key="'indexbo-' + itemBo.id"
                              class="mb-5 rounded-10 elevation-card"
                              width="100%"
                            >
                              <v-expansion-panel-header
                                expand-icon="keyboard_arrow_down"
                                class="primary pr-5 pl-0 py-0 rounded-bottom-left-10 rounded-bottom-right-10"
                              >
                                <template v-slot:actions>
                                  <v-icon
                                    color="white"
                                    style="font-size: 23px !important;"
                                  >
                                    keyboard_arrow_down
                                  </v-icon>
                                </template>
                                <template>
                                  <v-row no-gutters>
                                    <span
                                      class="pl-5 font-weight-bold fs-14 white--text align-self-center text-capitalize"
                                    >
                                      {{ itemBo.profile.desc }}
                                    </span>
                                  </v-row>
                                </template>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content class="px-2 py-4">
                                <form-approver
                                  :groupList="groupList"
                                  :approvers="itemBo.profile.approvers"
                                  :approverList="approverList"
                                  :isDetail="isDetail"
                                  :panel="panel"
                                  :parentPanel="parentPanel"
                                  :panelBo="panelBO"
                                  :isBo="true"
                                />
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-col cols="2" class=" ml-3 px-0 py-0">
                                    <v-btn
                                      id="btn-save"
                                      rounded
                                      block
                                      color="blue darken-3"
                                      @click="
                                        saveConfirm(
                                          'save',
                                          group.listType,
                                          itemBo,
                                          group,
                                          indexCondition
                                        )
                                      "
                                      class="white--text"
                                      :disabled="isDetail"
                                    >
                                      Save
                                    </v-btn>
                                  </v-col>
                                  <v-col cols="2" class=" ml-3 px-0 py-0">
                                    <v-btn
                                      id="btn-save"
                                      rounded
                                      block
                                      color="red"
                                      @click="
                                        saveConfirm(
                                          'reset',
                                          group.listType,
                                          itemBo,
                                          group,
                                          indexCondition
                                        )
                                      "
                                      class="white--text"
                                      :disabled="isDetail"
                                    >
                                      Reset
                                    </v-btn>
                                  </v-col>
                                </v-card-actions>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </v-container>
                      </v-card-text>
                      <v-card-actions v-if="group.listType === 'group'">
                        <v-spacer></v-spacer>
                        <v-col cols="2" class=" ml-3 px-0 py-0">
                          <v-btn
                            id="btn-save"
                            rounded
                            block
                            color="blue darken-3"
                            type="submit"
                            class="white--text"
                            :disabled="isDetail"
                          >
                            Save
                          </v-btn>
                        </v-col>
                        <v-col cols="2" class=" ml-3 px-0 py-0">
                          <v-btn
                            id="btn-save"
                            rounded
                            block
                            color="red"
                            @click="
                              saveConfirm(
                                'reset',
                                group.listType,
                                group,
                                group,
                                indexCondition
                              )
                            "
                            class="white--text"
                            :disabled="isDetail"
                          >
                            Reset
                          </v-btn>
                        </v-col>
                      </v-card-actions>
                    </v-form>
                  </v-perfect-scroll>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
    <v-dialog v-model="setEmailDialog" persistent max-width="700px">
      <v-card class="rounded-12">
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="saveEmailConfig" class="pa-0">
            <v-card-title
              class="primary white--text fs-16 lh-20 font-weight-bold py-4 px-6 text-uppercase"
            >
              <span class="pa-0">set email time</span>
              <v-spacer></v-spacer>
              <v-icon
                @click="setEmailDialog = false"
                color="white"
                class="fs-18"
                style="font-size: 20px !important; margin-right: -4px !important"
              >
                close
              </v-icon>
            </v-card-title>
            <v-card-text class="mt-8">
              <v-flex xs12>
                <v-row class="px-5">
                  <v-flex xs2 class="pt-4">
                    <span class="subtitle-2 font-weight-600 lightblack--text"
                      >Time</span
                    >
                  </v-flex>
                  <v-flex xs1 class="text-right pr-5 pt-4">
                    :
                  </v-flex>
                  <v-flex xs6>
                    <date-picker
                      v-model="time"
                      type="time"
                      format="HH"
                      placeholder="Time (hour)"
                      class="timePicker mt-2"
                      style="width: 66.7% !important;"
                    >
                    </date-picker>
                  </v-flex>
                  <v-flex xs12 class="mt-3">
                    <span class="fs-12">
                      Approval email will be sent at specified time.
                    </span>
                  </v-flex>
                </v-row>
              </v-flex>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mr-2" type="submit">
                SAVE
              </v-btn>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../progress_dialog';
import formApprover from './formApproval';
import moment from 'moment';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  name: 'approval',
  props: {
    node: {
      type: Object,
      required: true
    },
    isDetail: {
      type: Boolean
    },
    isEdit: {
      type: Boolean
    },
    triggerGetData: {
      type: Boolean
    }
  },
  components: {
    'progress-dialog': ProgressDialog,
    'form-approver': formApprover
  },
  data() {
    return {
      time: null,
      date: [],
      menu: false,
      setEmailDialog: false,
      progressDialogLoading: false,
      groupList: [],
      approverList: [],
      panel: null,
      parentPanel: null,
      panelBO: null,
      groups: [],
      tempConditional: {},
      tempConventional: {}
    };
  },
  computed: {
    div_id() {
      return this.node.division_id;
    }
  },
  watch: {
    div_id(val) {
      if (val) {
        this.getGroup();
      }
    },
    triggerGetData() {
      this.getGroup();
      this.panel = null;
    },
    'groupList.type'(newVal, oldVal) {
      this.panel = null;
      if (oldVal === 'conventional') {
        this.tempConventional = this.copy(this.groupList);
        this.tempConventional.type = 'conventional';
      } else {
        this.tempConditional = this.copy(this.groupList);
        this.tempConditional.type = 'conditional';
      }
      if (newVal === 'conventional') {
        // let groupList = this.tempConventional
        //   ? this.tempConventional
        //   : this.groupList;
        this.groupList.type = 'conventional';
        this.groupList.condition.length = 1;
      } else {
        this.groupList = this.tempConditional
          ? this.tempConditional
          : this.groupList;
        this.groupList.type = 'conditional';
      }
    },
    groupList: {
      handler() {
        if (this.parentPanel !== undefined) {
          let item = this.groupList.condition[this.parentPanel];
          if (item.max_amount < item.amount) {
            item.error_message = item.max_infinite
              ? ''
              : 'Max Amount can not smaller than Min Amount!';
          } else {
            item.error_message = '';
          }
        }
      },
      deep: true
    }
  },
  mounted() {
    this.getApprover();
  },
  methods: {
    setEmail() {
      this.progressDialogLoading = true;
      return this.$store
        .dispatch('approval/getConfigEmail')
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            console.log('time', data.data);
            let time = moment(new Date()).set('hour', data.data.hour);
            this.time = time._d;
            this.setEmailDialog = true;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    saveEmailConfig() {
      Swal.fire({
        title: '',
        text: 'Are you sure want to set the email time for Single Approval?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.updateTime();
        }
      });
    },
    updateTime() {
      this.progressDialogLoading = true;
      let params = {
        hour: moment(this.time).format('HH')
      };
      return this.$store
        .dispatch('approval/setConfigEmail', params)
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.setEmailDialog = false;
            Swal.fire({
              title: 'Success!',
              text: `${data.message.text_en}`,
              type: 'success',
              showCancelButton: false,
              confirmButtonText: 'OK'
            });
          } else {
            this.progressDialogLoading = false;
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    changeApprovalFlow(type) {
      Swal.fire({
        title: '',
        text: `Are you sure want to change this Approval Flow Type?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: `Yes`,
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.saveFlowType(type);
        } else {
          this.groupList.approval_flow = type === 'bulk' ? 'single' : 'bulk';
        }
      });
    },
    saveFlowType(type) {
      this.progressDialogLoading = true;
      const params = {
        divisi_id: this.div_id,
        type_approval: this.groupList.type,
        approval_flow: this.groupList.approval_flow
      };
      return this.$store
        .dispatch('approval/createApproval', params)
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            Swal.fire('Success!', data.message.text_en, 'success');
            this.panelBO = null;
            this.panel = null;
            this.getGroup();
            this.getApprover();
          } else {
            this.groupList.approval_flow = type === 'bulk' ? 'single' : 'bulk';
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.groupList.approval_flow = type === 'bulk' ? 'single' : 'bulk';
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    getBO(group) {
      if (group.budgetOwner.length === 0) {
        this.progressDialogLoading = true;
        return this.$store
          .dispatch('approval/getBO', group.id)
          .then(data => {
            this.progressDialogLoading = false;
            if (data.code === 200) {
              this.groupList.condition[this.parentPanel].group[
                this.panel
              ].budgetOwner = data.data.map(bo => {
                if (bo.profile.approvers.length === 0) {
                  bo.profile.approvers = [
                    {
                      id: null,
                      approval_level: 1,
                      skip_waiting_restriction: false
                    }
                  ];
                }
                return {
                  ...bo
                };
              });
            } else {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          });
      }
    },
    handleInfinite(item) {
      if (item.max_infinite) {
        item.max_amount = 0;
      }
    },
    updateCondition(item) {
      Swal.fire({
        title: '',
        text: 'Are you sure want to save this condition?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.progressDialogLoading = true;
          let params = {
            id: item.id,
            min_amount: item.amount,
            max_amount: item.max_amount,
            max_infinite: item.max_infinite,
            divisi_id: item.divisi_id ? item.divisi_id : this.div_id
          };
          return this.$store
            .dispatch('approval/updateCondition', params)
            .then(data => {
              this.progressDialogLoading = false;
              if (data.code === 200) {
                this.getGroup();
                this.getApprover();
                Swal.fire('Success!', data.message.text_en, 'success');
              } else {
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              }
            })
            .catch(err => {
              this.progressDialogLoading = false;
              this.loading = false;
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            });
        }
      });
    },
    addCondition() {
      this.groups = this.copy(this.groupList.condition[0].group);
      this.groupList.condition.push({
        amount: 0,
        max_amount: 0,
        max_infinite: false,
        group: this.groups.map(group => {
          group.approvers = [
            {
              approval_level: 1,
              skip_waiting_restriction: false
            }
          ];
          return group;
        })
      });
    },
    removeCondition(item, index) {
      Swal.fire({
        title: 'Are you sure want to remove this condition?',
        text: 'You will not be able to recover this condition!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          if (item.id) {
            this.progressDialogLoading = true;
            return this.$store
              .dispatch('approval/deleteCondition', item.id)
              .then(data => {
                this.progressDialogLoading = false;
                if (data.code === 200) {
                  Swal.fire('Success!', data.message.text_en, 'success');
                  this.getGroup();
                  this.getApprover();
                } else {
                  Swal.fire(
                    'Failed!',
                    data.response.data.message.text_en,
                    'error'
                  );
                }
              })
              .catch(err => {
                this.progressDialogLoading = false;
                this.loading = false;
                Swal.fire(
                  'Failed!',
                  err.response.data.message.text_en,
                  'error'
                );
              });
          } else {
            this.groupList.condition.splice(index, 1);
          }
        }
      });
    },
    getGroup() {
      this.progressDialogLoading = true;
      let params = {
        divisi_id: this.div_id
      };
      return this.$store
        .dispatch('approval/detailApprover', params)
        .then(data => {
          if (data.code === 200) {
            this.progressDialogLoading = false;
            if (data.data.result.type === 'conventional') {
              this.groupList = {
                type: data.data.result.type,
                condition: [
                  {
                    amount: 0,
                    max_amount: 0,
                    group: data.data.result.listGroup.map(group => {
                      if (group.approvers.length === 0) {
                        group.approvers = [
                          {
                            approver_id: null,
                            approval_level: 1,
                            skip_waiting_restriction: false
                          }
                        ];
                      }
                      return {
                        ...group,
                        listType: 'group',
                        budgetOwner: []
                      };
                    })
                  }
                ]
              };
            } else {
              this.groupList = {
                type: data.data.result.type,
                approval_flow: data.data.result.approval_flow,
                condition: data.data.result.conditionList.map(condition => {
                  condition.group.map(group => {
                    if (group.approvers.length === 0) {
                      group.approvers = [
                        {
                          approver_id: null,
                          approval_level: 1,
                          skip_waiting_restriction: false
                        }
                      ];
                    }
                    group.listType = 'group';
                    group.budgetOwner = [];
                    return group;
                  });
                  return condition;
                })
              };
            }
          } else {
            this.progressDialogLoading = false;
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    getApprover() {
      this.progressDialogLoading = true;
      return this.$store
        .dispatch('profile/getAll', {
          paginate: false
        })
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.approverList = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        });
    },
    saveConfirm(typeSave, type, item, itemGroup, indexCondition) {
      let isNotEmpty =
        type === 'group'
          ? item.approvers[0].approver_id
          : item.profile.approvers[0].approver_id;
      if (isNotEmpty) {
        Swal.fire({
          title: '',
          text: `Are you sure want to ${typeSave} this ${
            type === 'bo' ? 'Budget Owner' : 'Group'
          } Approver List?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: `Yes`,
          cancelButtonText: 'No'
        }).then(result => {
          if (result.value) {
            this.save(typeSave, type, item, itemGroup, indexCondition);
          }
        });
      } else {
        Swal.fire('Failed', `Please select the approver.`, 'error');
      }
    },
    save(typeSave, type, item, itemGroup, indexCondition) {
      this.progressDialogLoading = true;
      let isConditional = this.groupList.type === 'conditional';
      const params = {
        divisi_id: this.div_id,
        type_approval: this.groupList.type,
        approval_flow: this.groupList.approval_flow
          ? this.groupList.approval_flow
          : null,
        amount: isConditional
          ? this.groupList.condition[indexCondition].amount
          : null,
        max_amount: isConditional
          ? this.groupList.condition[indexCondition].max_amount
          : null,
        max_infinite: isConditional
          ? this.groupList.condition[indexCondition].max_infinite
          : null,
        condition_id: isConditional
          ? this.groupList.condition[indexCondition].id
          : null,
        group_id: type === 'group' ? item.id : itemGroup.id,
        budget_owner_id: type === 'bo' ? item.profile_id : null,
        approvers:
          typeSave === 'save'
            ? type === 'group'
              ? item.approvers.map((val, index) => {
                  return {
                    ...val,
                    approval_level: index + 1
                  };
                })
              : item.profile.approvers.map((val, index) => {
                  return {
                    ...val,
                    approval_level: index + 1
                  };
                })
            : []
      };
      return this.$store
        .dispatch('approval/createApproval', params)
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            Swal.fire('Success!', data.message.text_en, 'success');
            this.panelBO = null;
            this.panel = null;
            this.getGroup();
            this.getApprover();
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    resetApprover(type, item, itemGroup) {
      let isNotEmpty =
        type === 'group'
          ? item.approvers[0].approver_id
          : item.profile.approvers[0].approver_id;
      if (isNotEmpty) {
        Swal.fire({
          title: '',
          text: `Are you sure want to reset this ${
            type === 'bo' ? 'Budget Owner' : 'Group'
          } Approver List?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
        }).then(result => {
          if (result.value) {
            this.reset(type, item, itemGroup);
          }
        });
      } else {
        Swal.fire('Failed', `Please select the approver.`, 'error');
      }
    },
    reset(type, item, itemGroup) {
      this.progressDialogLoading = true;
      const params = {
        condition_id: this.groupList.condition[this.parentPanel].id,
        type_approval: this.groupList.type,
        divisi_id: this.div_id,
        group_id: type === 'group' ? item.id : itemGroup.id,
        budget_owner_id: type === 'bo' ? item.profile_id : null,
        approvers: []
      };
      return this.$store
        .dispatch('approval/createApproval', params)
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            Swal.fire('Success!', data.message.text_en, 'success');
            this.getGroup();
            this.getApprover();
            this.panel = null;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    }
  }
};
</script>
